export default "__VITE_ASSET__imc6H5$H__"